<template>
  <v-layout wrap>
    <v-textarea
      box
      :rows="rows"
      :label="fieldLabel"
      :disabled="readonly"
      v-on:blur="blurred()"
      v-model="text">
    </v-textarea>
  </v-layout>
</template>

<script>
import Helpers from "@/helpers.js"

export default {
  name: 'text-area',
  props: {
    field: {
      type: Object
    },
    data: {
      type: String
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    }
  },
  methods: {
    blurred() {
      this.$emit("blurred", {
        field: this.field.name,
        data: this.text,
        row: this.row
      })
    }
  },
  computed: {
    rows() {
      if (this.data && this.data.length>0) {
        const rows = this.data.split("\n")
        return rows.length < 5 ? rows.length : 5;
      } else {
        return 1;
      }
    },
    fieldLabel() {
      return (this.field.display_name) ? this.field.display_name : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    text: {
      get() {
        if (this.data) {
          return this.data
        } else {
          if (this.field && this.field.default_value) {
            return this.field.default_value
          } else {
            return ""
          }
        }
      },
      set(value) {
        this.$emit('update-item', { field: this.field.name, data: value, row: this.row })
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) { readonly = this.field.readonly }
      return readonly
    }
  }
}
</script>
